import React from "react";
import { Desabilitar } from "../../components/Mouse";

function Cooperados() {
  return (
    <>
      <Desabilitar />
      <div className="home">
        <iframe
          title="Cooperados"
          class="video"
          widht="100%"
          height="100%"
          src="https://app.powerbi.com/reportEmbed?reportId=a0228c3d-3e62-40eb-866d-7b7bc098a1fc&autoAuth=true&ctid=f88c7305-11d1-4b34-a8a0-da6536019e31"
          marginheight="0"
          marginwidth="0"
          scrolling="0"
          frameborder="0"
          allowFullScreen="true"
        ></iframe>
      </div>
    </>
  );
}

export default Cooperados;
